export const actions = {
  FECHA_BLOQUEADA_LOAD_REQUESTED: 'FECHA_BLOQUEADA_LOAD_REQUESTED',
  FECHA_BLOQUEADA_LOAD_SUCCEEDED: 'FECHA_BLOQUEADA_LOAD_SUCCEEDED',
  FECHA_BLOQUEADA_LOAD_FILED: 'FECHA_BLOQUEADA_LOAD_FILED',

  FECHA_BLOQUEADA_BY_ID_LOAD_REQUESTED: 'FECHA_BLOQUEADA_BY_ID_LOAD_REQUESTED',
  FECHA_BLOQUEADA_BY_ID_LOAD_SUCCEEDED: 'FECHA_BLOQUEADA_BY_ID_LOAD_SUCCEEDED',
  FECHA_BLOQUEADA_BY_ID_LOAD_FILED: 'FECHA_BLOQUEADA_BY_ID_LOAD_FILED',

  FECHA_BLOQUEADA_INSERT_REQUESTED: 'FECHA_BLOQUEADA_INSERT_REQUESTED',
  FECHA_BLOQUEADA_INSERT_SUCCEEDED: 'FECHA_BLOQUEADA_INSERT_SUCCEEDED',
  FECHA_BLOQUEADA_INSERT_FILED: 'FECHA_BLOQUEADA_INSERT_FILED',

  FECHA_BLOQUEADA_UPDATE_REQUESTED: 'FECHA_BLOQUEADA_UPDATE_REQUESTED',
  FECHA_BLOQUEADA_UPDATE_SUCCEEDED: 'FECHA_BLOQUEADA_UPDATE_SUCCEEDED',
  FECHA_BLOQUEADA_UPDATE_FILED: 'FECHA_BLOQUEADA_UPDATE_FILED',

  FECHA_BLOQUEADA_DELETE_REQUESTED: 'FECHA_BLOQUEADA_DELETE_REQUESTED',
  FECHA_BLOQUEADA_DELETE_SUCCEEDED: 'FECHA_BLOQUEADA_DELETE_SUCCEEDED',
  FECHA_BLOQUEADA_DELETE_FILED: 'FECHA_BLOQUEADA_DELETE_FILED',

  FECHA_BLOQUEADA_PROVINCIA_LOAD_REQUESTED: 'FECHA_BLOQUEADA_PROVINCIA_LOAD_REQUESTED',
  FECHA_BLOQUEADA_PROVINCIA_LOAD_SUCCEEDED: 'FECHA_BLOQUEADA_PROVINCIA_LOAD_SUCCEEDED',
  FECHA_BLOQUEADA_PROVINCIA_LOAD_FILED: 'FECHA_BLOQUEADA_PROVINCIA_LOAD_FILED',

  FECHA_BLOQUEADA_PROVINCIA_UPDATE_REQUESTED: 'FECHA_BLOQUEADA_PROVINCIA_UPDATE_REQUESTED',
  FECHA_BLOQUEADA_PROVINCIA_UPDATE_SUCCEEDED: 'FECHA_BLOQUEADA_PROVINCIA_UPDATE_SUCCEEDED',
  FECHA_BLOQUEADA_PROVINCIA_UPDATE_FILED: 'FECHA_BLOQUEADA_PROVINCIA_UPDATE_FILED',

  FECHA_BLOQUEADA_PROVINCIA_DELETE_REQUESTED: 'FECHA_BLOQUEADA_PROVINCIA_DELETE_REQUESTED',
  FECHA_BLOQUEADA_PROVINCIA_DELETE_SUCCEEDED: 'FECHA_BLOQUEADA_PROVINCIA_DELETE_SUCCEEDED',
  FECHA_BLOQUEADA_PROVINCIA_DELETE_FILED: 'FECHA_BLOQUEADA_PROVINCIA_DELETE_FILED',
}

export const getFechasBloqueadasAction = dispatch => {
  dispatch({
    type: actions.FECHA_BLOQUEADA_LOAD_REQUESTED,
  })
}

export const onSubmitFechaBloqueadaAction = (dispatch, fechaBloqueadaForm) => {
  dispatch({
    type: actions.FECHA_BLOQUEADA_INSERT_REQUESTED,
    payload: fechaBloqueadaForm,
  })
}

export const onSubmitFechaBloqueadaUpdateAction = (dispatch, fechaBloqueadaForm) => {
  dispatch({
    type: actions.FECHA_BLOQUEADA_UPDATE_REQUESTED,
    payload: fechaBloqueadaForm,
  })
}

export const deleteFechaBloqueadaAction = (dispatch, id) => {
  dispatch({
    type: actions.FECHA_BLOQUEADA_DELETE_REQUESTED,
    payload: id,
  })
}

export const getFechaBloqueadaProvinciasAction = (dispatch, fechaId) => {
  dispatch({
    type: actions.FECHA_BLOQUEADA_PROVINCIA_LOAD_REQUESTED,
    payload: fechaId,
  })
}

export const submitFechaBloqueadaProvinciaUpdateFormAction = (
  dispatch,
  fechaBloqueadaProvinciaForm,
) => {
  dispatch({
    type: actions.FECHA_BLOQUEADA_PROVINCIA_UPDATE_REQUESTED,
    payload: fechaBloqueadaProvinciaForm,
  })
}

export const deleteFechasBloqueadasProvinciasAction = (dispatch, fechaId) => {
  dispatch({
    type: actions.FECHA_BLOQUEADA_PROVINCIA_DELETE_REQUESTED,
    payload: fechaId,
  })
}
